import axios from 'axios'
axios.defaults.withCredentials = true;
const url = 'http://www.api.ucpvirtual.com.br/api/v2/med/'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
export default {
    
    actions:{

        async  AllArquivos (context, value) {
            // context.commit('PRELOADER_MUDAR', true)
            const AuthStr = 'Bearer ' + localStorage.getItem('access_token')
        
            await axios.get(url +'estudos/'+ value.id,
              {
                headers: {
                  'Authorization': AuthStr,
                  'Content-Type': 'application/json',
                },
              })
              .then(response => {
                 console.log(response.data)
                 context.commit('SET_ALL_ARQUIVOS', response.data)
              })
              .catch((error) => {
                console.log(error.response.data.message)
              }).finally( () => {
                    //   context.commit('PRELOADER_MUDAR', false)
              })
          },

        

    },
    getters:{

    },
    mutations:{
      SET_ALL_ARQUIVOS (state, value) {
            state.Arquivos =  value
          },

    },
    state:{
        Arquivos: [],

    },
}